define('directives/common/redactor',[
	"application",
	"jquery",
	"redactor"
], function (app, $) {

	return app.directives.directive("redactor", function () {

		return {
			restrict: "A",
			require: '?ngModel',
			controller: [
				"$scope", "$parse", function ($scope, $parse) {
					$scope.$parse = $parse;
				}
			],
			link: function (scope, el, attrs, ngModel) {
				var updateModel = function () {
					if (!scope.$$phase) {
						scope.$apply(ngModel.$setViewValue(el.redactor('get')));
					}
				};

				var uploadedCallback = function (file, json) {
				};

				var fileUploadErrorCallback = function (json) {
				};

				var options = {
					changeCallback: updateModel,
					xhtml: true,
					observeImages: true,
					fileUploadCallback: uploadedCallback,
					fileUploadErrorCallback: fileUploadErrorCallback,
					imageUploadCallback: uploadedCallback,
					imageUploadErrorCallback: fileUploadErrorCallback,
					formattingTags: ["h2", "h3", "h4", "h5", "p", "blockquote"],
					buttons: [
						"formatting",
						"|",
						"bold",
						"italic",
						"underline",
						"deleted",
						"|",
						"alignleft",
						"aligncenter",
						"alignright",
						"justify",
						"|",
						"unorderedlist",
						"orderedlist",
						"|",
						"outdent",
						"indent",
						"|",
						"image",
						"file",
						"table",
						"link",
						"horizontalrule",
						"|",
						"html"]
				};

				var additionalOptions = attrs.redactor ? scope.$eval(attrs.redactor) : {};
				angular.extend(options, additionalOptions);

				var editor = el.redactor(options);

				ngModel.$render = function () {
					if (angular.isDefined(editor)) {
						editor.redactor('set', ngModel.$viewValue || "");
					}
				};

				attrs.$observe("imageUpload", function (value) {
					var newValue = scope.$parse(value)(scope);

					if (angular.isDefined(editor) && newValue) {
						el.redactor("destroy");

						if (options)
							options.imageUpload = newValue;

						editor = el.redactor(options);
						ngModel.$render = function () {
							if (angular.isDefined(editor)) {
								editor.redactor('set', ngModel.$viewValue || "");
							}
						};
					}
				});

			}
		};

	});

});
